import * as React from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import request from "../../utilities/requests";
import { AppContext } from "../../contexts/AppContext";

const NotesDialog = ({ open, close, otherUser, eventId }) => {
  const {event: activeEvent} = React.useContext(AppContext);
  const event = eventId ? { _id: eventId } : activeEvent;
  const [notes, setNotes] = React.useState("");


  React.useEffect(() => {
    getNotes();
  },[])

  const getNotes = async () => {
    const result = await request(`pairing/mixernotes?eventId=${event._id}&otherUser=${otherUser}`);
    if (result.success) {
      if (result?.notes?.text){
        setNotes(result?.notes?.text);
      } else {
        setNotes("");
      }
    }
  };

  const saveNotes = async () => {
    if (notes === "") {
      close();
      return
    }
    const body = {
      eventId: event._id,
      otherUser,
      notes
    }
    const result = await request('pairing/mixernotes', "post", body);
    if (!result?.success) {
      alert(result.error);
    }
    close()
  }

  return (
    <Dialog
      open={open}
      onClose={() => close()}
      fullWidth
      PaperProps={{ sx: { borderRadius: "24px" } }}
    >
      <DialogTitle id="alert-dialog-title">{"Date notes"}</DialogTitle>
      <DialogContent>
        <TextField
          label="notes"
          multiline
          rows={10}
          fullWidth
          style={{ marginTop: 10 }}
          value={notes}
          onChange={(e) =>  setNotes(e.target.value)}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "20px",
              paddingLeft: "18px",
              paddingRight: "18px",
            },
            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
              borderWidth: "1px",
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                borderWidth: "1px",
              },
            "& .MuiInputLabel-root:not(.MuiInputLabel-shrink)": {
              marginLeft: "4px",
            },
          }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          className="tnfm-pill-btn"
          style={{ minHeight: 32, paddingLeft: 16, paddingRight: 16 }}
          onClick={() => close()}
          autoFocus
        >
          Cancel
        </Button>
        <Button
          className="tnfm-pill-btn"
          style={{ minHeight: 32, paddingLeft: 24, paddingRight: 24 }}
          variant="contained"
          onClick={() => saveNotes()}
          autoFocus
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotesDialog;
